import React from "react";
import { Collapse } from "antd";
import { _Filter_Items } from "..";
import { TenantCheckbox } from ".";
const SelectedPanelColor = "#bae7ff";
const { Panel } = Collapse;
function Recursive({ _Label, _Childrens, _ApiTag, _SectionApiTag, dispatch, resursiveValue, _extra, tenant }) {
	return (
		<Collapse
			defaultActiveKey={["1"]}
			onChange={() => {}}
			style={{
				"background-color": _Childrens.some(({ _ApiTag }) => resursiveValue?.[_ApiTag])
					? SelectedPanelColor
					: "#f0f0f0f0"
			}}
		>
			<Panel
				header={_Label}
				key={_ApiTag}
				extra={
					<>
						{_extra && (
							<>
								<TenantCheckbox tenant={tenant} _ApiTag={_ApiTag} _extra={_extra} dispatch={dispatch} />
							</>
						)}
					</>
				}
			>
				{_Childrens.map(({ _ApiTag: _Child_ApiTag, _Label: _Child_Label, _Childrens, _Type }) => {
					return _Filter_Items[_Type]({
						_SectionApiTag,
						_Label: _Child_Label,
						_ApiTag: _Child_ApiTag,
						_Childrens,
						value: resursiveValue ? resursiveValue[_Child_ApiTag] : [],
						dispatch
					});
				})}
			</Panel>
		</Collapse>
	);
}

export default Recursive;
